export const barSliderPadding = 20;
export const indicatorSize = 22;
